import defaults from './session-storage.json'
import { LocalJsonStore } from './LocalJsonStore'
import type { SessionRecord, SessionStorageFile } from './SessionTypes'

const STORAGE_KEY = 'masterhub.session-manager'

export class SessionRepository {
  private readonly store = new LocalJsonStore<SessionStorageFile>(
    STORAGE_KEY,
    defaults as SessionStorageFile,
  )

  getFile(): SessionStorageFile {
    return this.store.load()
  }

  saveFile(file: SessionStorageFile): boolean {
    return this.store.save({
      ...file,
      updatedAt: new Date().toISOString().slice(0, 10),
    })
  }

  list(): SessionRecord[] {
    return [...this.getFile().sessions].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
  }

  findById(id: string): SessionRecord | null {
    return this.getFile().sessions.find((s) => s.id === id) ?? null
  }

  findByIntegrationId(integrationId: string): SessionRecord[] {
    return this.list().filter((s) => s.integrationId === integrationId)
  }

  upsert(record: SessionRecord): SessionRecord {
    const file = this.getFile()
    const index = file.sessions.findIndex((s) => s.id === record.id)
    const sessions =
      index >= 0
        ? file.sessions.map((s, i) => (i === index ? record : s))
        : [...file.sessions, record]
    this.saveFile({ ...file, sessions })
    return record
  }

  remove(id: string): boolean {
    const file = this.getFile()
    const sessions = file.sessions.filter((s) => s.id !== id)
    if (sessions.length === file.sessions.length) return false
    this.saveFile({ ...file, sessions })
    return true
  }

  reset(): SessionStorageFile {
    return this.store.reset()
  }
}

export const sessionRepository = new SessionRepository()
